import { connect } from "react-redux";
import ListAgentsComponent from "../../Components/Agents/ListAgentsComponent";
import { setAgents } from "../../Redux/Actions/AgentsActions";
const mapStateToProps = (state) => ({
    ACTIVE_TENANT: state.reducer.ACTIVE_TENANT,
    AGENTS : state.reducer.AGENTS,
    AGENT_PROFILES : state.reducer.AGENT_PROFILES,
    SCOPES_NAMES: state.reducer.SCOPES_NAMES,
});
const mapDispatchToProps = (dispatch) => ({
    setAgents : (AGENTS) => dispatch(setAgents(AGENTS)),
});
 
export default connect(mapStateToProps, mapDispatchToProps)(ListAgentsComponent);